<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-2"></div>
        <main class="col-9 " role="main">
          <h5 class="text-left">Nouveau remplacant !</h5>
          <div class="float-left">
            <form v-on:submit.prevent class="titulaire-form">
              <div class="form-group row">
                <label for="salutation" class="col-4 control-label"
                  >Salutation</label
                >
                <div class="col-7">
                  <select v-model="salutation" class="form-control">
                    <option disabled value="">Salutation</option>
                    <option>Monsieur</option>
                    <option>Madame</option>
                    <option>Docteur</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="nom" class="col-4 control-label"> Nom</label>
                <div class="col-7">
                  <input
                    autofocus
                    required
                    v-model.trim="nom"
                    placeholder="Nom"
                    autocomplete="off"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="prenom" class="col-4 control-label">Prénom</label>
                <div class="col-7">
                  <input
                    v-model.trim="prenom"
                    class="form-control"
                    placeholder="Prénom"
                    autocomplete="off"
                    type="text"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="adresse" class="col-4 control-label">Adresse</label>
                <div class="col-7">
                  <input
                    v-model.trim="adresse"
                    name="adresse"
                    type="text"
                    class="form-control"
                    placeholder="Adresse"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="col-4 control-label"> Email</label>
                <div class="col-7">
                  <input
                    v-model.trim="email"
                    name="email"
                    type="text"
                    class="form-control"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="telephone" class="col-4 control-label"
                  >Telephone</label
                >
                <div class="col-7">
                  <input
                    name="telephone"
                    type="text"
                    class="form-control"
                    placeholder="Num. téléphone"
                    v-model.trim="telephone"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="ordre" class="col-4 control-label">
                  Num. conseil de l'ordre</label
                >
                <div class="col-7">
                  <input
                    name="ordre"
                    type="text"
                    class="form-control"
                    placeholder="Num. conseil de l'ordre"
                    v-model.trim="ordre"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="urssaf" class="col-4 control-label">Urssaf</label>
                <div class="col-7">
                  <input
                    name="urssaf"
                    type="text"
                    class="form-control"
                    placeholder="Num. Urssaf"
                    v-model.trim="urssaf"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="typeContrat" class="col-4 control-label"
                  >Type de Contrat</label
                >
                <div class="col-7">
                  <select v-model="typeContrat" class="form-control">
                    <option disabled value="">Type de contrat</option>
                    <option>Médecin</option>
                    <option>Etudiant</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="lieuNaiss" class="col-4 control-label"
                  >Lieu de naissance</label
                >
                <div class="col-7">
                  <input
                    name="lieuNaiss"
                    type="text"
                    class="form-control"
                    placeholder="Lieu de naissance"
                    v-model.trim="lieuNaiss"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 control-label"> Autre assurance ?</label>
                <div class="col-7">
                  <select
                    v-model="autreAssurance"
                    name="autre_assurance"
                    type="text"
                    class="form-control"
                  >
                    <option selected value="true"> Oui</option>
                    <option value="false"> Non</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 control-label"> Date de naissance</label>
                <div class="col-7">
                  <input
                    v-model="dateNaiss"
                    name="date_naiss"
                    type="date"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="row">
                <button
                  class="btn btn-primary"
                  type="submit"
                  @click="addRemplacant"
                >
                  Valider
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import AppNav from "./AppNav";
import { ALL_REMPLACANTS_QUERY, CREATE_REMPLACANT } from "../constants/graphql";

const pageSize = 10;

export default {
  name: "remplacants-new",
  components: {
    AppNav
  },
  data() {
    return {
      nom: "",
      prenom: "",
      ordre: "",
      telephone: "",
      email: "",
      adresse: "",
      salutation: "",
      typeContrat: "",
      urssaf: "",
      lieuNaiss: "",
      autreAssurance: "",
      dateNaiss: null
    };
  },
  methods: {
    addRemplacant() {
      const nom = this.nom;
      const prenom = this.prenom;
      const email = this.email;
      const ordre = this.ordre;
      const adresse = this.adresse;
      const telephone = this.telephone;
      const salutation = this.salutation;
      const typeContrat = this.typeContrat;
      const urssaf = this.urssaf;
      const lieuNaiss = this.lieuNaiss;
      const autreAssurance = this.autreAssurance;
      const dateNaiss = this.dateNaiss;
      this.$apollo
        .mutate({
          mutation: CREATE_REMPLACANT,
          variables: {
            nom: this.nom,
            prenom: this.prenom,
            email: this.email,
            ordre: this.ordre,
            adresse: this.adresse,
            telephone: this.telephone,
            salutation: this.salutation,
            typeContrat: this.typeContrat,
            urssaf: this.urssaf,
            lieuNaiss: this.lieuNaiss,
            autreAssurance: this.autreAssurance === "true" ? true : false,
            dateNaiss: this.dateNaiss,
            actif: true
          },
          refetchQueries: [
            {
              query: ALL_REMPLACANTS_QUERY
            }
          ]
        })
        .then(data => {
          router.push({ name: "Remplacants" });
        })
        .catch(error => {
          // Error
          console.error(error);
          // We restore the initial user input
          this.nom = nom;
          this.prenom = prenom;
          this.email = email;
          this.ordre = ordre;
          this.adresse = adresse;
          this.telephone = telephone;
          this.salutation = salutation;
          this.typeContrat = typeContrat;
          this.urssaf = urssaf;
          this.lieuNaiss = lieuNaiss;
          this.autreAssurance = autreAssurance;
          this.dateNaiss = dateNaiss;
        });
    }
  },
  mounted() {}
};
</script>
<style scoped>
body {
  padding-top: 3.5rem;
}
/*
 * Typography
 */

h1 {
  margin-bottom: 20px;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}
/*
 * Sidebar
 */
.sidebar {
  position: fixed;
  top: 51px;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  /* Scrollable contents if viewport is shorter than content. */
  border-right: 1px solid #eee;
}

/* Sidebar navigation */

.sidebar {
  padding-left: 0;
  padding-right: 0;
}

.sidebar .nav {
  margin-bottom: 20px;
}

.sidebar .nav-item {
  width: 100%;
}

.sidebar .nav-item + .nav-item {
  margin-left: 0;
}

.sidebar .nav-link {
  border-radius: 0;
}

/*
 * Dashboard
 */

/* Placeholders */

.placeholders {
  padding-bottom: 3rem;
}

.placeholder img {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

select option[data-default] {
  display: none;
}

.medecins-form {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// remplacantsNew.vue?1104a276